import { useCallback, useMemo } from 'react';
import { wrapIn } from 'prosemirror-commands';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { RTEToolbarButton } from '../components/StyledTextToolbarButton';
import { TextToolbarIcon } from 'rich-text-lib/components/editor/TextToolbarIcon';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import useDebouncedEditorStateContext from '../contexts/useDebouncedEditorStateContext';
import { buildBlockLiftTransaction } from '../utils/blockUtils';
import { InsertQuoteIcon } from 'foundations-assets/icons/components/InsertQuoteIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default function Blockquote() {
  const {
    editorState,
    setEditorState
  } = useDebouncedEditorStateContext();
  const hasList = useMemo(() => {
    let listItemFound = false;
    editorState.doc.nodesBetween(editorState.selection.from, editorState.selection.to, node => {
      if (node.type === editorState.schema.nodes.bullet_list || node.type === editorState.schema.nodes.ordered_list) {
        listItemFound = true;
        return false;
      }
      return true;
    });
    return listItemFound;
  }, [editorState]);
  const hasBlockquote = useMemo(() => {
    let blockQuoteFound = false;
    editorState.doc.nodesBetween(editorState.selection.from, editorState.selection.to, node => {
      if (node.type === editorState.schema.nodes.blockquote) {
        blockQuoteFound = true;
        return false;
      }
      return true;
    });
    return blockQuoteFound;
  }, [editorState]);
  const toggleBlockquote = useCallback(e => {
    e.preventDefault();
    if (hasBlockquote) {
      const liftTr = buildBlockLiftTransaction(editorState, editorState.schema.nodes.blockquote);
      return setEditorState(editorState.apply(liftTr));
    }
    return wrapIn(editorState.schema.nodes.blockquote)(editorState, tr => setEditorState(editorState.apply(tr)));
  }, [editorState, setEditorState, hasBlockquote]);
  return /*#__PURE__*/_jsx(Tooltip, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "hubspot-prosemirror.tooltips.blockquote"
    }),
    children: /*#__PURE__*/_jsx(RTEToolbarButton, {
      "data-test-id": "blockquote",
      onClick: toggleBlockquote,
      selected: hasBlockquote,
      disabled: hasList,
      children: /*#__PURE__*/_jsx(TextToolbarIcon, {
        icon: InsertQuoteIcon,
        disabled: hasList
      })
    })
  });
}